import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Silence the benign "ResizeObserver loop completed with undelivered notifications" warning
// that Radix Popover / react-day-picker throw on modal open. Runs BEFORE React mounts so it
// intercepts the earliest events too (otherwise CRA's dev error overlay traps them).
if (typeof window !== "undefined") {
  const _isResizeLoop = (msg) =>
    typeof msg === "string" && msg.startsWith("ResizeObserver loop");
  const swallow = (e) => {
    const msg = (e && (e.message || e.reason?.message)) || "";
    if (_isResizeLoop(msg)) {
      e.stopImmediatePropagation?.();
      e.preventDefault?.();
      return true;
    }
    return false;
  };
  window.addEventListener("error", swallow, true);
  window.addEventListener("unhandledrejection", swallow, true);
  const _origConsoleError = console.error.bind(console);
  console.error = (...args) => {
    if (_isResizeLoop(args[0])) return;
    _origConsoleError(...args);
  };
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
